// src/components/LoadingDots.tsx
import React from "react";

const LoadingDots = () => {
  return (
    <div className="flex items-center space-x-2 p-4">
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" />
      <div
        className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
        style={{ animationDelay: "0.2s" }}
      />
      <div
        className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
        style={{ animationDelay: "0.4s" }}
      />
    </div>
  );
};

export default LoadingDots;
